// // if (!customElements.get('quick-add-modal')) {
// //   customElements.define(
// //     'quick-add-modal',
// //     class QuickAddModal extends ModalDialog {
// //       constructor() {
// //         super();
// //         this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

// //         this.addEventListener('product-info:loaded', ({ target }) => {
// //           target.addPreProcessCallback(this.preprocessHTML.bind(this));
// //         });
// //       }

// //       hide(preventFocus = false) {
// //         const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
// //         if (cartNotification) cartNotification.setActiveElement(this.openedBy);
// //         this.modalContent.innerHTML = '';

// //         if (preventFocus) this.openedBy = null;
// //         super.hide();
// //       }

// //       show(opener) {
// //         opener.setAttribute('aria-disabled', true);
// //         opener.classList.add('loading');
// //         opener.querySelector('.loading__spinner').classList.remove('hidden');

// //         fetch(opener.getAttribute('data-product-url'))
// //           .then((response) => response.text())
// //           .then((responseText) => {
// //             const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
// //             const productElement = responseHTML.querySelector('product-info');

// //             this.preprocessHTML(productElement);
// //             HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

// //             if (window.Shopify && Shopify.PaymentButton) {
// //               Shopify.PaymentButton.init();
// //             }
// //             if (window.ProductModel) window.ProductModel.loadShopifyXR();

// //             super.show(opener);
// //           })
// //           .finally(() => {
// //             opener.removeAttribute('aria-disabled');
// //             opener.classList.remove('loading');
// //             opener.querySelector('.loading__spinner').classList.add('hidden');
// //           });
// //       }

// //       preprocessHTML(productElement) {
// //         productElement.classList.forEach((classApplied) => {
// //           if (classApplied.startsWith('color-') || classApplied === 'gradient')
// //             this.modalContent.classList.add(classApplied);
// //         });
// //         this.preventDuplicatedIDs(productElement);
// //         this.removeDOMElements(productElement);
// //         this.removeGalleryListSemantic(productElement);
// //         this.updateImageSizes(productElement);
// //         this.preventVariantURLSwitching(productElement);
// //       }

// //       preventVariantURLSwitching(productElement) {
// //         productElement.setAttribute('data-update-url', 'false');
// //       }

// //       removeDOMElements(productElement) {
// //         const pickupAvailability = productElement.querySelector('pickup-availability');
// //         if (pickupAvailability) pickupAvailability.remove();

// //         const productModal = productElement.querySelector('product-modal');
// //         if (productModal) productModal.remove();

// //         const modalDialog = productElement.querySelectorAll('modal-dialog');
// //         if (modalDialog) modalDialog.forEach((modal) => modal.remove());
// //       }

// //       preventDuplicatedIDs(productElement) {
// //         const sectionId = productElement.dataset.section;

// //         const oldId = sectionId;
// //         const newId = `quickadd-${sectionId}`;
// //         productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
// //         Array.from(productElement.attributes).forEach((attribute) => {
// //           if (attribute.value.includes(oldId)) {
// //             productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
// //           }
// //         });

// //         productElement.dataset.originalSection = sectionId;
// //       }

// //       removeGalleryListSemantic(productElement) {
// //         const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
// //         if (!galleryList) return;

// //         galleryList.setAttribute('role', 'presentation');
// //         galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
// //       }

// //       updateImageSizes(productElement) {
// //         const product = productElement.querySelector('.product');
// //         const desktopColumns = product?.classList.contains('product--columns');
// //         if (!desktopColumns) return;

// //         const mediaImages = product.querySelectorAll('.product__media img');
// //         if (!mediaImages.length) return;

// //         let mediaImageSizes =
// //           '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

// //         if (product.classList.contains('product--medium')) {
// //           mediaImageSizes = mediaImageSizes.replace('715px', '605px');
// //         } else if (product.classList.contains('product--small')) {
// //           mediaImageSizes = mediaImageSizes.replace('715px', '495px');
// //         }

// //         mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
// //       }
// //     }
// //   );
// // }

// if (!customElements.get('quick-add-modal')) {
//   customElements.define(
//     'quick-add-modal',
//     class QuickAddModal extends ModalDialog {
//       constructor() {
//         super();
//         this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

//         this.addEventListener('product-info:loaded', ({ target }) => {
//           target.addPreProcessCallback(this.preprocessHTML.bind(this));
//         });
//       }

//       hide(preventFocus = false) {
//         const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         if (cartNotification) cartNotification.setActiveElement(this.openedBy);
//         this.modalContent.innerHTML = '';

//         if (preventFocus) this.openedBy = null;
//         super.hide();
//       }

//       show(opener) {
//         opener.setAttribute('aria-disabled', true);
//         opener.classList.add('loading');
//         opener.querySelector('.loading__spinner').classList.remove('hidden');

//         fetch(opener.getAttribute('data-product-url'))
//           .then((response) => response.text())
//           .then((responseText) => {
//             const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
//             const productElement = responseHTML.querySelector('product-info');

//             this.preprocessHTML(productElement);
//             HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

//             if (window.Shopify && Shopify.PaymentButton) {
//               Shopify.PaymentButton.init();
//             }
//             if (window.ProductModel) window.ProductModel.loadShopifyXR();

//             super.show(opener);
//             this.initQuickViewWidgets();
//           })
//           .finally(() => {
//             opener.removeAttribute('aria-disabled');
//             opener.classList.remove('loading');
//             opener.querySelector('.loading__spinner').classList.add('hidden');
//           });
//       }

//       preprocessHTML(productElement) {
//         productElement.classList.forEach((classApplied) => {
//           if (classApplied.startsWith('color-') || classApplied === 'gradient')
//             this.modalContent.classList.add(classApplied);
//         });
//         this.preventDuplicatedIDs(productElement);
//         this.removeDOMElements(productElement);
//         this.removeGalleryListSemantic(productElement);
//         this.updateImageSizes(productElement);
//         this.preventVariantURLSwitching(productElement);
//         this.promoteDeferredCss(productElement);
//         this.activateGokwikBuyNow(productElement);
//         this.customizeQuickViewContent(productElement);
//       }

//       // Theme lazy-loads CSS by emitting <link d-href="..."> and promoting to href
//       // via a head-script that only runs on initial page load. Injected markup needs
//       // the same promotion or the modal renders unstyled.
//       promoteDeferredCss(productElement) {
//         productElement.querySelectorAll('link[d-href]').forEach((link) => {
//           link.setAttribute('href', link.getAttribute('d-href'));
//           link.removeAttribute('d-href');
//         });
//       }

//       // Re-run page-level bootstraps that were scoped to DOMContentLoaded —
//       // they never re-fire for HTML injected after page load. Scope every
//       // selector to this.modalContent so nothing on the host page is touched.
//       initQuickViewWidgets() {
//         const root = this.modalContent;
//         if (!root) return;

//         // Swiper galleries from custom-media-gallery.liquid
//         const mainEl = root.querySelector('.product-main-swiper');
//         if (window.Swiper && mainEl) {
//           const thumbsEl = root.querySelector('.product-thumbs-swiper');
//           const thumbsSwiper = thumbsEl
//             ? new window.Swiper(thumbsEl, {
//                 slidesPerView: 4,
//                 spaceBetween: 10,
//                 watchSlidesProgress: true,
//                 navigation: {
//                   nextEl: root.querySelector('.thumb-next'),
//                   prevEl: root.querySelector('.thumb-prev'),
//                 },
//               })
//             : null;
//           new window.Swiper(mainEl, {
//             slidesPerView: 1,
//             loop: true,
//             speed: 600,
//             grabCursor: true,
//             pagination: { el: root.querySelector('.pagintion-common'), clickable: true },
//             navigation: {
//               nextEl: root.querySelector('.arrow-div.nex'),
//               prevEl: root.querySelector('.arrow-div.prev'),
//             },
//             ...(thumbsSwiper ? { thumbs: { swiper: thumbsSwiper } } : {}),
//           });
//         }

//         // Read More toggle from main-product.liquid description block
//         root.querySelectorAll('.desc-wrapper').forEach((wrapper) => {
//           const btn = wrapper.querySelector('.read-more-btn');
//           if (!btn) return;
//           btn.addEventListener('click', () => {
//             wrapper.classList.toggle('expanded');
//             btn.textContent = wrapper.classList.contains('expanded') ? 'Read Less' : 'Read More';
//           });
//         });
//       }

//       // gokwik.liquid enables #gokwik-buy-now on a one-time 'gokwikLoaded' event,
//       // which fired before the modal was injected — so the button would stay
//       // .disabled and the spinner would never hide.
//       activateGokwikBuyNow(productElement) {
//         const buyNow = productElement.querySelector('#gokwik-buy-now');
//         if (!buyNow) return;
//         buyNow.classList.remove('disabled');
//         buyNow.disabled = false;
//       }

//       // Modal-only tweaks: show description; drop nutrition popup,
//       // collapsible accordions, and the icon-with-text trust badges;
//       // suppress the .class-info::after decorative image.
//       customizeQuickViewContent(productElement) {
//         const desc = productElement.querySelector('.product__description');
//         if (desc) desc.classList.remove('quick-add-hidden');

//         const removeSelectors = ['.nutrition-popup', '.my-accordion', '.icon-with-text', '.coupon-section'];
//         removeSelectors.forEach((sel) => {
//           productElement.querySelectorAll(sel).forEach((n) => n.remove());
//         });

//         const overrideStyle = document.createElement('style');
//         overrideStyle.textContent = 'quick-add-modal .class-info::after { content: none !important; }';
//         productElement.prepend(overrideStyle);
//       }

//       preventVariantURLSwitching(productElement) {
//         productElement.setAttribute('data-update-url', 'false');
//       }

//       removeDOMElements(productElement) {
//         const pickupAvailability = productElement.querySelector('pickup-availability');
//         if (pickupAvailability) pickupAvailability.remove();

//         const productModal = productElement.querySelector('product-modal');
//         if (productModal) productModal.remove();

//         const modalDialog = productElement.querySelectorAll('modal-dialog');
//         if (modalDialog) modalDialog.forEach((modal) => modal.remove());
//       }

//       preventDuplicatedIDs(productElement) {
//         const sectionId = productElement.dataset.section;

//         const oldId = sectionId;
//         const newId = `quickadd-${sectionId}`;
//         productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
//         Array.from(productElement.attributes).forEach((attribute) => {
//           if (attribute.value.includes(oldId)) {
//             productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
//           }
//         });

//         productElement.dataset.originalSection = sectionId;
//       }

//       removeGalleryListSemantic(productElement) {
//         const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
//         if (!galleryList) return;

//         galleryList.setAttribute('role', 'presentation');
//         galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
//       }

//       updateImageSizes(productElement) {
//         const product = productElement.querySelector('.product');
//         const desktopColumns = product?.classList.contains('product--columns');
//         if (!desktopColumns) return;

//         const mediaImages = product.querySelectorAll('.product__media img');
//         if (!mediaImages.length) return;

//         let mediaImageSizes =
//           '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

//         if (product.classList.contains('product--medium')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '605px');
//         } else if (product.classList.contains('product--small')) {
//           mediaImageSizes = mediaImageSizes.replace('715px', '495px');
//         }

//         mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
//       }
//     }
//   );
// }
if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
            this.initQuickViewWidgets();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
        this.promoteDeferredCss(productElement);
        this.activateGokwikBuyNow(productElement);
        this.customizeQuickViewContent(productElement);
      }

      // Theme lazy-loads CSS by emitting <link d-href="..."> and promoting to href
      // via a head-script that only runs on initial page load. Injected markup needs
      // the same promotion or the modal renders unstyled.
      promoteDeferredCss(productElement) {
        productElement.querySelectorAll('link[d-href]').forEach((link) => {
          link.setAttribute('href', link.getAttribute('d-href'));
          link.removeAttribute('d-href');
        });
      }

      // Re-run page-level bootstraps that were scoped to DOMContentLoaded —
      // they never re-fire for HTML injected after page load. Scope every
      // selector to this.modalContent so nothing on the host page is touched.
      initQuickViewWidgets() {
        const root = this.modalContent;
        if (!root) return;

        // Swiper galleries from custom-media-gallery.liquid
        const mainEl = root.querySelector('.product-main-swiper');
        if (window.Swiper && mainEl) {
          const thumbsEl = root.querySelector('.product-thumbs-swiper');
          const thumbsSwiper = thumbsEl
            ? new window.Swiper(thumbsEl, {
                slidesPerView: 4,
                spaceBetween: 10,
                watchSlidesProgress: true,
                navigation: {
                  nextEl: root.querySelector('.thumb-next'),
                  prevEl: root.querySelector('.thumb-prev'),
                },
              })
            : null;
          new window.Swiper(mainEl, {
            slidesPerView: 1,
            loop: true,
            speed: 600,
            grabCursor: true,
            pagination: { el: root.querySelector('.pagintion-common'), clickable: true },
            navigation: {
              nextEl: root.querySelector('.arrow-div.nex'),
              prevEl: root.querySelector('.arrow-div.prev'),
            },
            ...(thumbsSwiper ? { thumbs: { swiper: thumbsSwiper } } : {}),
          });
        }

        // Read More toggle from main-product.liquid description block
        root.querySelectorAll('.desc-wrapper').forEach((wrapper) => {
          const btn = wrapper.querySelector('.read-more-btn');
          if (!btn) return;
          btn.addEventListener('click', () => {
            wrapper.classList.toggle('expanded');
            btn.textContent = wrapper.classList.contains('expanded') ? 'Read Less' : 'Read More';
          });
        });
      }

      // gokwik.liquid enables #gokwik-buy-now on a one-time 'gokwikLoaded' event,
      // which fired before the modal was injected — so the button would stay
      // .disabled and the spinner would never hide.
      activateGokwikBuyNow(productElement) {
        const buyNow = productElement.querySelector('#gokwik-buy-now');
        if (!buyNow) return;
        buyNow.classList.remove('disabled');
        buyNow.disabled = false;
      }

      // Modal-only tweaks: show description; drop nutrition popup,
      // collapsible accordions, and the icon-with-text trust badges;
      // suppress the .class-info::after decorative image.
      customizeQuickViewContent(productElement) {
        const desc = productElement.querySelector('.product__description');
        if (desc) desc.classList.remove('quick-add-hidden');

        const removeSelectors = ['.nutrition-popup', '.my-accordion', '.icon-with-text', '.coupon-section'];
        removeSelectors.forEach((sel) => {
          productElement.querySelectorAll(sel).forEach((n) => n.remove());
        });

        const overrideStyle = document.createElement('style');
        overrideStyle.textContent = 'quick-add-modal .class-info::after { content: none !important; }';
        productElement.prepend(overrideStyle);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
